(() => {
  if (window.kjCollectionFiltersBound) return;
  window.kjCollectionFiltersBound = true;
  let trigger;
  const drawer = () => document.getElementById('KJFilterDrawer');
  function syncPrice(form) {
    form.querySelectorAll('[data-kj-price]').forEach(group => {
      ['min', 'max'].forEach(key => {
        const input = group.querySelector(`[data-kj-price-input="${key}"]`);
        const range = group.querySelector(`[data-kj-range="${key}"]`);
        range.value = input.value || (key === 'min' ? 0 : range.max);
      });
    });
  }
  function close() {
    const dialog = drawer();
    if (!dialog) return;
    dialog.querySelector('form').reset();
    syncPrice(dialog.querySelector('form'));
    dialog.close();
    document.body.classList.remove('kj-filter-open');
    if (trigger?.isConnected) trigger.focus();
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-kj-open]');
    if (opener) {
      const dialog = drawer();
      if (!dialog) return;
      trigger = opener;
      const mode = opener.dataset.kjOpen;
      dialog.querySelector('form').reset();
      syncPrice(dialog.querySelector('form'));
      dialog.querySelectorAll('[data-kj-panel]').forEach(panel => panel.hidden = panel.dataset.kjPanel !== mode);
      dialog.querySelector('[data-kj-clear]').hidden = mode === 'sort';
      dialog.querySelector('h2').textContent = mode === 'sort' ? 'Sort by' : 'Filters';
      document.body.classList.add('kj-filter-open');
      dialog.showModal();
      dialog.querySelector('.kj-filter-body').scrollTop = 0;
      dialog.querySelector('[data-kj-close]').focus();
    }
    if (event.target.closest('[data-kj-close]')) close();
    const dialog = drawer();
    if (dialog && event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    }
    if (event.target.closest('[data-kj-clear]')) {
      const panel = dialog.querySelector('[data-kj-panel="filter"]');
      panel.querySelectorAll('input[type="checkbox"]').forEach(input => input.checked = false);
      panel.querySelectorAll('input[type="number"]').forEach(input => input.value = '');
      syncPrice(dialog.querySelector('form'));
    }
  });
  document.addEventListener('cancel', event => {
    if (event.target.id === 'KJFilterDrawer') { event.preventDefault(); close(); }
  }, true);
  document.addEventListener('input', event => {
    const input = event.target;
    const group = input.closest('[data-kj-price]');
    if (!group) return;
    const low = group.querySelector('[data-kj-price-input="min"]');
    const high = group.querySelector('[data-kj-price-input="max"]');
    low.setCustomValidity(''); high.setCustomValidity('');
    if (input.matches('[data-kj-range]')) {
      const key = input.dataset.kjRange;
      let value = Number(input.value);
      if (key === 'min') value = Math.min(value, Number(high.value || high.max));
      else value = Math.max(value, Number(low.value || 0));
      group.querySelector(`[data-kj-price-input="${key}"]`).value = value;
      input.value = value;
    } else syncPrice(input.form);
  });
  document.addEventListener('submit', event => {
    if (event.target.id !== 'KJFilterForm') return;
    event.preventDefault();
    const form = event.target;
    for (const group of form.querySelectorAll('[data-kj-price]')) {
      const low = group.querySelector('[data-kj-price-input="min"]');
      const high = group.querySelector('[data-kj-price-input="max"]');
      if (Number(low.value || 0) > Number(high.value || high.max)) {
        low.setCustomValidity('Minimum price must not exceed maximum price.');
        low.reportValidity(); return;
      }
    }
    const url = new URL(location.href);
    // Keep unrelated storefront parameters, reset pagination, replace only our filters.
    [...url.searchParams.keys()].forEach(key => {
      if (key.startsWith('filter.') || key === 'sort_by' || key === 'page' || key === 'section_id') url.searchParams.delete(key);
    });
    for (const [key, value] of new FormData(form)) if (String(value).trim()) url.searchParams.append(key, value);
    form.querySelector('[type="submit"]').disabled = true;
    form.querySelector('[type="submit"]').textContent = 'Loading...';
    location.assign(url.href);
  });
  // Restore button state if the browser returns this page from its back-forward cache.
  window.addEventListener('pageshow', () => {
    const dialog = drawer();
    if (!dialog) return;
    if (dialog.open) close();
    const button = dialog.querySelector('[type="submit"]');
    button.disabled = false; button.textContent = 'Show results';
  });
})();
